<template>
  <div class="editable-page-model2"
       :style="{width:editablePageConfig.editable_page_config_content.width,backgroundColor:editablePageConfig.editable_page_config_content.back_color,paddingTop:editablePageConfig.editable_page_config_content.margin_top,paddingBottom:editablePageConfig.editable_page_config_content.margin_bottom}">
    <div class="html" v-html="editablePageConfig.editable_page_config_content.editor[0]"></div>
  </div>
</template>

<script>
export default {
  name: 'Model2',
  data () {
    return {
    }
  },
  props: ['editablePageConfig'],
  computed: {

  },
  methods: {
    // souece 原字符串 start 要截取的位置 newStr 要插入的字符
    // insertStr (source, start, newStr) {
    //   return source.slice(0, start) + newStr + source.slice(start)
    // }

  },
  created () {
	  //注释测试
    // this.editablePageConfig.editable_page_config_content.editor[0] = this.editablePageConfig.editable_page_config_content.editor[0].slice(0, 151) + 'wap/' + this.editablePageConfig.editable_page_config_content.editor[0].slice(151)
    // this.editablePageConfig.editable_page_config_content.editor[0] = this.editablePageConfig.editable_page_config_content.editor[0].slice(0, 433) + 'wap/' + this.editablePageConfig.editable_page_config_content.editor[0].slice(433)
    // this.editablePageConfig.editable_page_config_content.editor[0] = this.editablePageConfig.editable_page_config_content.editor[0].slice(0, 715) + 'wap/' + this.editablePageConfig.editable_page_config_content.editor[0].slice(715)
    // this.editablePageConfig.editable_page_config_content.editor[0] = this.editablePageConfig.editable_page_config_content.editor[0].slice(0, 973) + 'wap/' + this.editablePageConfig.editable_page_config_content.editor[0].slice(973)
    // this.editablePageConfig.editable_page_config_content.editor[0] = this.editablePageConfig.editable_page_config_content.editor[0].slice(0, 1209) + 'wap/' + this.editablePageConfig.editable_page_config_content.editor[0].slice(1209)
	
	//end
    // this.insertStr(this.editablePageConfig.editable_page_config_content.editor[0], 1, 'wap/') // 2020-0808
	//start注释
    if (this.editablePageConfig.editable_page_config_content.editor[0].includes('http://mobile.baixinshangcheng.com/')){
	// if (this.editablePageConfig.editable_page_config_content.editor[0].includes('http://mobilecs.baixinshangcheng.com/')){
      this.editablePageConfig.editable_page_config_content.editor[0] = this.editablePageConfig.editable_page_config_content.editor[0].replace(/http:/g, 'https:')

      // if (this.editablePageConfig.editable_page_config_content.editor[0].includes('mobile')) {
      //   this.editablePageConfig.editable_page_config_content.editor[0] = this.editablePageConfig.editable_page_config_content.editor[0].replace(/mobile/g, 'www')
      // }
      // console.log(this.editablePageConfig.editable_page_config_content.editor[0], '9999999999-----99999')
    }
	if (this.editablePageConfig.editable_page_config_content.editor[0].includes('http://baixinshangcheng.com/')){
		this.editablePageConfig.editable_page_config_content.editor[0] = this.editablePageConfig.editable_page_config_content.editor[0].replace(/http:/g, 'https:')
	}
	if (this.editablePageConfig.editable_page_config_content.editor[0].includes('http://www.baixinshangcheng.com/')){
		this.editablePageConfig.editable_page_config_content.editor[0] = this.editablePageConfig.editable_page_config_content.editor[0].replace(/http:/g, 'https:')
	}
	//end注释
  }
}
</script>

<style lang="scss">
.editable-page-model2 .html *{max-width:100%}
</style>
